import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_MARKET_LEGACY_PACKS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToLegacyPacksPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_MARKET_LEGACY_PACKS)}
      replace
    />
  );
};
export default RedirectToLegacyPacksPage;
